import script from "./ExpertComp.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpertComp.vue?vue&type=script&setup=true&lang=js"

import "./ExpertComp.vue?vue&type=style&index=0&id=6dc45c2b&lang=css"

const __exports__ = script;

export default __exports__